import React from 'react';
import ContentSectionComponent from '../Content-Section-Component';

const returnWithValue = (field: string) => {
    return {
        value: field,
    }
}

const returnExtraClassName = (extraClassField: any) => {
    if (!extraClassField) return '';
    const parsed = JSON.parse(extraClassField);
    if (Array.isArray(parsed.classes)) {
        return parsed.classes.map((item: any) => item.className.value).join(' ');
    }
    return parsed.className?.value || '';
}

const FlexSection = (props?: any) => {

    const { fields = {}, params, rendering } = props;

    const styles: React.CSSProperties = {};

    const extraClass = {
        fields: {
            className: {
                value: (params?.extraClass) ? returnExtraClassName(params.extraClass || '') : ''
            }
        }
    }

    if (params?.overlayColor || params?.overlayOverride) {
        extraClass.fields.className.value += ' imc-section--overlay';
        if (params?.overlayColor) {
            (styles as any)['--overlay-color'] = `var(--${params.overlayColor})`;
        }
        if (params?.overlayOverride) {
            (styles as any)['--overlay-color'] = params.overlayOverride;
        }
        if (params?.overlayOpacity) {
            (styles as any)['--overlay-opacity'] = `${params.overlayOpacity}%`;
        }
    }

    if (params?.backgroundOverride) {
        extraClass.fields.className.value += ' imc-section--custom-bg-color';
        (styles as any)['--bg-color'] = params.backgroundOverride;
    }

    const backgroundColor = returnWithValue(params?.backgroundColor || '')

    const backgroundImage = {
        value: (props?.params?.backgroundImage) ? JSON.parse(props.params.backgroundImage) : null
    }

    const videoFile = {
        value: (props?.params?.videoFile) ? JSON.parse(props.params.videoFile) : null
    }

    const paddingTop = returnWithValue(params?.paddingTop || '');
    const paddingBottom = returnWithValue(params?.paddingBottom || '');
    const paddingLeft = returnWithValue(params?.paddingLeft || '');
    const paddingRight = returnWithValue(params?.paddingRight || '');

    const marginTop = returnWithValue(params?.marginTop || '');
    const marginBottom = returnWithValue(params?.marginBottom || '');
    const marginLeft = returnWithValue(params?.marginLeft || '');
    const marginRight = returnWithValue(params?.marginRight || '');

    const processedFields = {
        ...fields,
        ...(!fields && params ? params : {}),
        extraClass,
        backgroundColor,
        backgroundImage,
        videoFile,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
        styles,
    }

    return (
        <>
            <ContentSectionComponent
                {...props}
                fields={processedFields}
                rendering={rendering}
            />
        </>
    );
};

export default FlexSection;
